import React, {useState, forwardRef} from 'react';
import TextField, {TextFieldProps} from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const PasswordTextField = forwardRef<HTMLInputElement, TextFieldProps>(({...props}, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleMouseDownPassword = () => {
        setShowPassword(true);
    };

    const handleMouseUpPassword = () => {
        setShowPassword(false);
    };

    const handleMouseLeavePassword = () => {
        setShowPassword(false);
    };

    return (
        <TextField
            {...props}
            type={showPassword ? 'text' : 'password'}
            inputRef={ref}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onMouseDown={handleMouseDownPassword}
                            onMouseUp={handleMouseUpPassword}
                            onMouseLeave={handleMouseLeavePassword}
                            onTouchStart={handleMouseDownPassword}
                            onTouchEnd={handleMouseUpPassword}
                            edge="end"
                            tabIndex={-1}
                        >
                            {showPassword ? <VisibilityOff/> : <Visibility/>}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
});

export default PasswordTextField;
